import Ably from "ably"
import { apiServerUrl, HEADER_MEMBER_API_KEY, HEADER_TEAM_API_KEY } from "~/constants";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { 
    MSG_IMPORT_LIST_STARTED, MSG_IMPORT_LIST_COMPLETED,
    MSG_IMPORT_TAG_STARTED, MSG_IMPORT_TAG_COMPLETED,
    MSG_EXPORT_SEGMENT_STARTED, MSG_EXPORT_SEGMENT_COMPLETED,
    MSG_EXPORT_LIST_STARTED, MSG_EXPORT_LIST_COMPLETED,
    MSG_EXPORT_TAG_STARTED, MSG_EXPORT_TAG_COMPLETED,
    MSG_EXPORT_CAMPAIGN_STARTED, MSG_EXPORT_CAMPAIGN_COMPLETED,
    MSG_BULK_ACTION_STARTED, MSG_BULK_ACTION_COMPLETED, MSG_BULK_ACTION_FAILED,
    MSG_MX_SEGMENT_SCAN_STARTED, MSG_MX_SEGMENT_SCAN_COMPLETED, MSG_MX_SEGMENT_SCAN_FAILED
} from "~/constants/toastMessages";

// Initialize the Ably Realtime client
function createTokenRequest() {
  const globalStore = useGlobalStore();
  if (!globalStore.$state.authInfo) {
   throw createError({ statusCode: 404, statusMessage: 'Auth Info not setup' })
  }

  const apiKey = globalStore.$state?.currentTeam?.apiKey ?? "";
  return new Promise((resolve, reject) => {
    useFetch(apiServerUrl() + "team/ably/token-request", {
      method: "GET",
      headers: {
        [HEADER_TEAM_API_KEY]: apiKey,
      },
    }).then((res) => {
        const tokenRes = res.data.value;
        const error = res.error.value;
        if (error) {
          console.log("token request error: ", error);
          reject(error);
        } else {
          console.log("token request", tokenRes)
          resolve(tokenRes)
        }
      }
    ).catch((e) => {
      reject(e);
    });
  })
}

export default defineNuxtPlugin((nuxtApp) => {
  let ablyClient = null;

  function initChannel() {
    const globalStore = useGlobalStore(); 
    let teamId = globalStore.$state.currentTeam?.id;
    let channel = ablyClient.channels.get("message-" + teamId);

    channel.subscribe(({ data }) => {
      console.log("Message received from Ably for event type => ", data.type);
      if(data.data && typeof data.data === 'string' && data.data.length > 0){
        data.data = JSON.parse(data.data);
      }
      switch (data.type) {
        case 0: {  // Updated Auth Info 
          globalStore.ablyAuthInfoUpdate({data: data.authInfo})
          break;
        }
        case 1: {  // Updated Account
          globalStore.ablyAccountUpdate({data: data.account})
          break;
        }
        case 2: {  // Updated Team
          globalStore.ablyTeamUpdate({data: data.team})
          break;
        }
        case 3: {  // Updated Member
          globalStore.ablyMemberUpdate({data: data.member})
          break;
        }
        case 4: {  // Updated Member Role
          globalStore.ablyMemberRoleUpdate({memberRole: data.memberRole, member: data.member})
          break;
        }
        case 5: { //File import succeded
          if(data?.data?.length !== 0){
            toast(data.data, {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 6: { // File Import Failed
          if(data?.data?.length !== 0){
            toast(data.data, {
              theme: "auto",
              type: "error",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 7: { // Notification for list import started
          console.log("Notification for list import started", data.data);
          if(data?.data?.length !== 0){
            toast(MSG_IMPORT_LIST_STARTED(data.data.name), {
              theme: "auto", 
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 8: { // Notification for list import completed
          console.log("Notification for list import completed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_IMPORT_LIST_COMPLETED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 9: { // Notification for tag import started
          console.log("Notification for tag import started", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_IMPORT_TAG_STARTED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 10: { // Notification for tag import completed
          console.log("Notification for tag import completed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_IMPORT_TAG_COMPLETED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 11: { // Notification for segment export started
          console.log("Notification for segment export started", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_EXPORT_SEGMENT_STARTED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 12: { // Notification for segment export completed
          console.log("Notification for segment export completed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_EXPORT_SEGMENT_COMPLETED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 13: { // Notification for list export started
          console.log("Notification for list export started", data.data.name);
          if(data?.data?.length !== 0){
            console.log("Notification for list export started", data.data.name, data.data);
            toast(MSG_EXPORT_LIST_STARTED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 14: { // Notification for list export completed
          console.log("Notification for list export completed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_EXPORT_LIST_COMPLETED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
            break;
        }
        case 15: { // Notification for tag export started
          console.log("Notification for tag export started", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_EXPORT_TAG_STARTED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 16: { // Notification for tag export completed
          console.log("Notification for tag export completed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_EXPORT_TAG_COMPLETED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 17: { // Notification for campaign started
          console.log("Notification for campaign started", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_EXPORT_CAMPAIGN_STARTED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 18: { // Notification for campaign completed 
          console.log("Notification for campaign export completed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_EXPORT_CAMPAIGN_COMPLETED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 19: { // Notification for bulk action started
          console.log("Notification for bulk action started", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_BULK_ACTION_STARTED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 20: { // Notification for bulk action completed
          console.log("Notification for bulk action completed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_BULK_ACTION_COMPLETED(data.data.name), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 21: { // Notification for bulk action failed
          console.log("Notification for bulk action failed", data.data.name);
          if(data?.data?.length !== 0){
            toast(MSG_BULK_ACTION_FAILED(data.data.name), {
              theme: "auto",
              type: "error",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 26: { // Notification for bulk action failed
          console.log("notification alert");
          globalStore.setNotificationAlert(true);
          break;
        }
        case 27: { // Transfer Ownership
          console.log("Transfer ownership notification received");
          globalStore.ablyTransferOwnerShip({ data: data.data });
          break;
        }
        case 28: { // Notification for MX segment scan started
          console.log("Notification for MX segment scan started", data.data);
          if(data?.data?.length !== 0){
            toast(MSG_MX_SEGMENT_SCAN_STARTED(), {
              theme: "auto", 
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 29: { // Notification for MX segment scan completed
          console.log("Notification for MX segment scan completed", data.data);
          if(data?.data?.length !== 0){
            toast(MSG_MX_SEGMENT_SCAN_COMPLETED(), {
              theme: "auto",
              type: "success",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
        case 30: { // Notification for MX segment scan failed
          console.log("Notification for MX segment scan failed", data.data);
          if(data?.data?.length !== 0){
            toast(MSG_MX_SEGMENT_SCAN_FAILED(), {
              theme: "auto",
              type: "error",
              hideProgressBar: false,
              autoClose: 3000,
              transition: "slide",
            });
          }
          break;
        }
      }
    });
  }

  const initializeAbly = () => {
    const globalStore = useGlobalStore();
    try {
      ablyClient = new Ably.Realtime({
        authCallback: async (tokenParams, callback) => {
          if (globalStore.$state.authInfo !== null) {
            try {
              const tokenRequest = await createTokenRequest();
              console.log("Token params", tokenParams);
              callback(null, tokenRequest);
              await ablyClient.connection.once("connected");
              initChannel();
            } catch (error) {
              console.log("Error getting token request : ", error)
              callback(error, null);
            }
          }
        },
        disconnectedRetryTimeout: 2000,
      });
      nuxtApp.provide('ably', ablyClient)
    } catch (error) {
      console.error("Error initializing Ably Realtime client:", error);
    }
  };

  // Call initializeAbly here to start attempting to authenticate
  initializeAbly();
});
